import { Check } from "../components/Check";
import { AddressStandard } from "../components/InputTypeRadio";
import { Popup } from "../components/Popup";
import { PublicPlace } from "../components/PublicPlace";
import { addClassAccount, formatFractionalNumber, loadingGrid, removeCifrao, saveGrid, sortArrayObject } from "../functionsGlobal";
import IconTrash from '../assets/GlobalIcons/IconTrash.svg'
import { RedirectButton } from "../shared/GlobalStyles/styles";
import { WrapperImg } from "../pages/secure/SaleLocalNew/styles";
import { stockTeleSale } from "../utils/useCategoryTeleSalesUtils";
import { FormatedToLowCase } from '../shared/Functions'


const formatedStocke = () => {
    const stock = FormatedToLowCase(stockTeleSale())
    return stock
}


const column = {
    product:  [                  
        {field:'id', headerName:'Id', type:'integer', order: '', }, 
        {field:'nome', headerName:'Nome', type:'string', order:'', }, 
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {field:'preco_compra', headerName:'Preço Compra', type:'number', order: '', }, 
        {field:'preco_venda', headerName:'Preço Venda', type:'number', order: '', },
        {field:'estoque', headerName:'Estoque', type:'number', order: '', currency:false}
    ],
    productTeleSale:  [                  
        {field:'nome', headerName:'Nome', type:'string', order:'', }, 
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {field: stockTeleSale(), headerName: formatedStocke(), type:'number', order: '', currency:false}
    ],
    complement:[
        {field:'codigo', headerName:'Código', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'preco_venda', headerName:'Preço', type:'number', order: ''},
    ],
    groupComplement:[
        {field:'nome', headerName:'Nome', type:'string', order: ''}
    ],
    client:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'telefone1', headerName:'Telefone', type:'string', order: ''},
        {field:'logradouro', headerName:'Endereço Padrão', type:'string', order: ''},
    ],
    attendants:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'codigo', headerName:'Código', type:'string', order: ''},
        {field:'comissao', headerName:'Comissão', type:'number', order: ''},
    ],
    deliveryMan:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
    ],
    user:[
        {field:'id', headerName:'Id', type:'integer', order: ''}, 
        {field:'nome', headerName:'Nome', type:'string', order:''}, 
        {field:'login', headerName:'Login', type:'string', order: ''}, 
    ],
    formOfPayment:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'tipo', headerName:'Tipo', type:'integer', order: ''},
    ],
    revenue: [
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'descricao', headerName:'Descrição', type:'string', order: ''},
    ],
    expense:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'descricao', headerName:'Descrição', type:'string', order: ''},
    ],
    currentAccount:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'descricao', headerName:'Descrição', type:'string', order: ''},
        {field:'saldo', headerName:'Saldo', type:'number', order: ''},
    ],
    billsToPay:[
        {field:'color', headerName:'', type:'', order: '', RenderCell: ({item}) => (
            <div className={`${addClassAccount(item)} colors`} />
        )},
        {field:'marcar', headerName:'', type:'check', order: '', RenderCell:({item, index, handleClick}) => (
            <Check handleClick={handleClick} index={index} item={item}/>
        )},
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'dt_vencimento', headerName:'Vencimento', type:'date', order: ''},
        {field:'dt_vencimento_original', headerName:'Vencimento Original', type:'date', order: ''},
        {field:'obs', headerName:'Obs', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    billsToPayPending:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'dt_pagamento', headerName:'Pagamento', type:'date', order: ''},
        {field:'dt_vencimento', headerName:'Vencimento', type:'date', order: ''},
        {field:'dt_vencimento_original', headerName:'Vencimento Original', type:'date', order: ''},
        {field:'obs', headerName:'Obs', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    billsToPayCanceled: [   
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'dt_cancelamento', headerName:'Cancelamento', type:'date', order: ''},
        {field:'dt_vencimento', headerName:'Vencimento', type:'date', order: ''},
        {field:'dt_vencimento_original', headerName:'Vencimento Original', type:'date', order: ''},
        {field:'obs', headerName:'Obs', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    billsToReceive: [
        {field:'color', headerName:'', type:'', order: '', RenderCell: ({item}) => (
            <div className={`${addClassAccount(item)} colors`} />
        )},
        {field:'marcar', headerName:'', type:'check', order: '', RenderCell:({item, index, handleClick}) => (
            <Check handleClick={handleClick} index={index} item={item}/>
        )},
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'dt_vencimento', headerName:'Vencimento', type:'date', order: ''},
        {field:'dt_vencimento_original', headerName:'Vencimento Original', type:'date', order: ''},
        {field:'obs', headerName:'Obs', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    billsToReceivePending:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'dt_recebimento', headerName:'Recebimento', type:'date', order: ''},
        {field:'dt_vencimento', headerName:'Vencimento', type:'date', order: ''},
        {field:'dt_vencimento_original', headerName:'Vencimento Original', type:'date', order: ''},
        {field:'obs', headerName:'Obs', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    billsToReceiveCanceled:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'dt_cancelamento', headerName:'Cancelamento', type:'date', order: ''},
        {field:'dt_vencimento', headerName:'Vencimento', type:'date', order: ''},
        {field:'dt_vencimento_original', headerName:'Vencimento Original', type:'date', order: ''},
        {field:'obs', headerName:'Obs', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    freight:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'localidade', headerName:'localidade', type:'string', order: ''},
        {field:'cidade', headerName:'Cidade', type:'string', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
    ],
    freightRay:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'de', headerName:'De', type:'number', order: '', currency: false},
        {field:'ate', headerName:'Até', type:'number', order: '', currency: false},
        {field:'tempo_medio', headerName:'Tempo Médio', type:'integer', order: ''},
        {field:'valor', headerName:'Valor', type:'number', order: ''},
    ],
    consultSaleFinish:[
        {field:'origem', headerName:'Origem', type:'string', order: ''},
        {field:'data', headerName:'Data', type:'date', order: ''},
        {field:'hora', headerName:'Hora', type:'string', order: ''},
        {field:'serie', headerName:'Série', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'integer', order: ''},
        {field:'cliente', headerName:'Cliente', type:'string', order: ''},
        {field:'acrescimo', headerName:'Acréscimo', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
        {field:'troco', headerName:'Troco', type:'number', order: ''},
    ],
    consultSaleCancel:[
        {field:'origem', headerName:'Origem', type:'string', order: ''},
        {field:'data', headerName:'Data', type:'date', order: ''},
        {field:'hora', headerName:'Hora', type:'string', order: ''},
        {field:'serie', headerName:'Série', type:'integer', order: ''},
        {field:'numero', headerName:'Número', type:'integer', order: ''},
        {field:'cliente', headerName:'Cliente', type:'string', order: ''},
        {field:'acrescimo', headerName:'Acréscimo', type:'number', order: ''},
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
        {field:'troco', headerName:'Troco', type:'number', order: ''},
    ],
    consultItemsSale:[
        {field:'qtd', headerName:'Qtd', type:'integer', order: ''},
        {field:'nome_produto', headerName:'Itens', type:'string', order: ''},
        {field:'codigo', headerName:'Código', type:'string', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    consultItemsNoteEntry:[
        {field:'qtd', headerName:'Qtd', type:'integer', order: ''},
        {field:'nome_produto', headerName:'Itens', type:'string', order: ''},
        {field:'codigo', headerName:'Código', type:'string', order: ''},
        {field:'total', headerName:'Total', type:'number', order: ''},
    ],
    consultNoteEntry:[
        {field:'ori', headerName:'Origem', type:'string', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},
        {field:'data', headerName:'Data', type:'date', order: ''},  
        {field:'numero_nfe', headerName:'Número', type:'integer', order: ''},  
        {field:'desconto', headerName:'Desconto', type:'number', order: ''},  
        {field:'total', headerName:'Total', type:'number', order: ''},  
    ],
    addressList:[
        {field:'logradouro', headerName:'Endereço', type:'string', order: '', RenderCell: ({item}) => (
        <PublicPlace  listItem={item}/>
        )},
        {field:'padrao', headerName:'Padrão', type:'check', order: '', RenderCell: ({item, index, handleClick}) => (
            <AddressStandard  listItem={item} index={index} handleClick={handleClick}/>
        )},  
        {field:'acoes', headerName:'Ações', type:'dropDown', order: '', RenderCell: ({item}) => {
            const props =  column.addressList[2].props;
            return <Popup listItem={item} {...props}/>

        }, props: {}}, 
 
    ],
    manuFactory:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},   
    ],
    section:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'descricao', headerName:'Descrição', type:'string', order: ''},   
    ],
    cfop:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'natureza', headerName:'Natureza', type:'string', order: ''},   
        {field:'cfop', headerName:'CFOP', type:'integer', order: ''},
        {field:'objetivo', headerName:'Objetivo', type:'string', order: ''},   
        {field:'tipo', headerName:'Tipo', type:'string', order: ''},   
    ],
    ncm:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'ncm', headerName:'Ncm', type:'integer', order: ''},   
        {field:'descricao', headerName:'Descricão', type:'integer', order: ''},   
    ],
    importGroupComplement:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},  
        {field:'isCheck', headerName:'', type:'check', order: '', RenderCell:({item, index, handleClick}) => (
            <Check handleClick={handleClick} index={index} item={item} keyName={'isCheck'}/>
        )}, 
    ],
    importComplement:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'nome', headerName:'Nome', type:'string', order: ''},  
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {field:'preco_venda', headerName:'Preço', type:'number', order: '', }, 
        {field:'isCheck', headerName:'', type:'check', order: '', RenderCell:({item, index, handleClick}) => (
            <Check handleClick={handleClick} index={index} item={item} keyName={'isCheck'}/>
        )}, 
    ],
    modalAddress:[
        {field:'id', headerName:'Id', type:'integer', order: ''},
        {field:'logradouro', headerName:'Endereço', type:'string', order: ''},
        {field:'numero', headerName:'Número', type:'string', order: ''},  
        {field:'cep', headerName:'CEP', type:'string', order: '', }, 
        {field:'bairro', headerName:'Bairro', type:'string', order: '', }, 
        {field:'cidade', headerName:'Cidade', type:'string', order: '', }, 
    ],
    separationProduct:[
        {field:'check', headerName:'OK', type:'check', order: '', RenderCell:({item, index, handleClick}) => (
            <Check handleClick={handleClick} index={index} item={item} keyName={'check'}/>
        )}, 
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {field:'nome', headerName:'Nome', type:'string', order: ''},  
        {field:'quantidade', headerName:'Quantidade', type:'string', order: '', numberWithComma: true},  
    ],
    productValidation:[
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {
            field:'qtd', headerName:'Quantidade', type:'number', order: '', numberWithComma: true, editable: true,
            valueFormatter: formatFractionalNumber,
            valueParser: (value) => value.toString().replace(',', '.'),
         },  
        {field:'msg', headerName:'Mensagem', type:'string', order: '',},  
        {field:'delete', headerName:'', type:'delete', order: '',  RenderCell: ({ item, index, handleClick }) => (
            <div onClick={() => handleClick(item, index)}>
                <img src={IconTrash} alt="imagem de uma lixeira" />
            </div>
            ),},  

    ],
    cadEmpresas:[
        {field:'nome_empresa', headerName:'Empresa', type:'string', order: '', }, 
        {field:'valor', headerName:'CNPJ', type:'string', order: '', RenderCell: ({ item, index, handleClick}) => (
           <RedirectButton 
                width={'100%'}
                onClick={() => handleClick(item, index)}
            >
            Entrar
            </RedirectButton>
        )}, 

    ],
    label:[
        {field:'id', headerName:'ID', type:'integer', order: '', }, 
        {field:'nome', headerName:'Nome', type:'string', order: '', }, 
        {field:'qtd', headerName:'Quantidade', type:'string', order: '', }, 
        {field:'modelo', headerName:'Modelo', type:'string', order: ''}, 
    ],
    sangriaAndSupply:[
        {field:'id', headerName:'ID', type:'integer', order: '', }, 
        {field:'data', headerName:'Data', type:'date', order: '', }, 
        {field:'hora', headerName:'Hora', type:'string', order: '', }, 
        {field:'tipo', headerName:'Tipo', type:'string', order: '', }, 
        {field:'total', headerName:'Total', type:'number', order: ''}, 
        {field:'nome_forma_pagamento', headerName:'Forma de Pagamento', type:'string', order: '', }, 
        {field:'obs', headerName:'Obs', type:'string', order: '', }, 
        {field:'usuario', headerName:'Usuário', type:'string', order: '', }, 
    ],
    ExchangeClient:[
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {field:'nome_produto', headerName:'Nome', type:'string', order: '', }, 
        {field:'qtd', headerName:'Qtd', type:'integer', order: ''}, 
        {field:'preco', headerName:'Preço', type:'number', order: '', }, 
        {field:'total', headerName:'Total', type:'number', order: '', }, 
        {field:'qtd_restante', headerName:'Qtd Restante', type:'integer', order: ''}, 
    ],
    ExchangeClientProduct:[
        {
            field:'delete', headerName:'', type:'delete', order: '',  RenderCell: ({ item, index, handleClick }) => (
            <div onClick={() => handleClick(item, index)}>
                <img src={IconTrash} alt="imagem de uma lixeira" />
            </div>
            ),},
        {field:'codigo', headerName:'Código', type:'string', order: '', }, 
        {field:'nome_produto', headerName:'Nome', type:'string', order: '', }, 
        {field:'qtd', headerName:'Qtd', type:'integer', order: '',}, 
        {field:'preco', headerName:'Preço', type:'number', order: '', }, 
        {field:'total', headerName:'Total', type:'number', order: '', }, 
    ],
    worthExchange:[
        {field:'id', headerName:'ID', type:'integer', order: '', }, 
        {field:'cliente', headerName:'Cliente', type:'string', order: '', }, 
        {field:'data', headerName:'Data', type:'date', order: '', }, 
        {field:'valor', headerName:'Valor', type:'number', order: '', }, 
        {field:'valor_utilizado', headerName:'Valor utilizado', type:'number', order: '', }, 
        {field:'usuario', headerName:'Usuário', type:'string', order: '', }, 
    ],
    pdv:[
        {field:'delete', headerName:'', type:'delete', order: '',  RenderCell: ({ item, index, handleClick }) => (
            <div onClick={() => handleClick(item, index)}>
                <img src={IconTrash} alt="imagem de uma lixeira" />
            </div>
            ),
        },  
        {field:'foto', headerName:'', type:'', order: '', RenderCell: ({ item, index, handleClick }) => (
            <WrapperImg onClick={() => handleClick(item, index)}>
                <img src={item?.foto} alt={item?.descricao || ''} />
            </WrapperImg>
            )
        }, 
        {field:'nome', headerName:'Descrição', type:'string', order: ''}, 
        {field:'qtd', headerName:'Qtd', type:'number', order: '',      numberWithComma: true, currency:false}, 
        {field:'preco_venda', headerName:'Preço Un', type:'number', order: '', }, 
        {field:'total', headerName:'Preço Total', type:'number', order: '', }, 
    ],
}


export const objFunctions = {
    productValidation:{
        qtd: {
            valueFormatter: formatFractionalNumber,
            valueParser: (value) => parseFloat(value.replace(',', '.')).toFixed(3)
        },
        delete: {
            RenderCell: ({ item, index, handleClick }) => (
            <div onClick={() => handleClick(item, index)}>
                <img src={IconTrash} alt="imagem de uma lixeira" />
            </div>
            ),
        },
    },
}


const getColumns = (key) => {
    return column[key];
}

export const setComponentInPropertyColumn = (key, keyField, props) => {
    column[key].map(item => { if (item.field === keyField)item.props =  {...props.rest}})
}

const verifyProperty = (key = null, columns) => {
    const resultRenderCell = [...column[key]]
    columns.map((item) => {
        resultRenderCell.filter(el => {
            if(item.field === el.field) {
                item.RenderCell = el.RenderCell;
            }
            return item
        })
    })

    return {column: column[key]}
}

const spreedObj = (key) => {
    [...column[key]].map(item => {
        return {
            ...item,
            ...(objFunctions['productValidation'][item.qtd] || {})

        }
    })

    return key
}

const verifyQtdColumns = (key) => {
    const resultArrayGrid = loadingGrid(key, objFunctions['productValidation']?? null);
    const resultColumnsDefault  = getColumns((spreedObj(key)));
    if(resultArrayGrid.length > 0 ) return resultArrayGrid
    if(resultColumnsDefault.length > 0)return resultColumnsDefault
} 

export const mountingColumns = (key, rows) => {
    const resultArrayGrid = verifyQtdColumns(key);
    if(rows.length === 0) return [{ columns: resultArrayGrid, rows: [] }];
    let columns = [];
    columns = resultArrayGrid;
    if(resultArrayGrid.length === 0 ) columns = getColumns(key);

    else {
        const {column} = verifyProperty(key, columns);
        const resultOrder = column.filter(item => item.order !== '');

        if(resultOrder.length > 0){
            const [{field, type, order}] = resultOrder;
            rows = sortArrayObject(rows, order, field, type);
        }
        else {
            const resultOrder = columns.filter(item => item.order !== '')
            if(resultOrder.length > 0){
                const [{field, type, order}] = resultOrder;
                rows = sortArrayObject(rows, order, field, type);

            }
        }
    }
    return [{ columns, rows }];
}

export const updateState = (nameState, state = '', tag = [], key = null,  callback) => {
    state[0][key] = tag
    saveGrid(state, nameState);
    callback([...state])
}
